import LegalHero from "../components/legal/LegalHero";
import LegalSections from "../components/legal/LegalSections";



export default function LegalPage() {
    return (
        <div className="min-h-screen bg-slate-950 text-white">
            <LegalHero />
            <LegalSections />
        </div>
    );
}
